module.exports = __webpack_public_path__ + "img/博野油漆与胶带2.85053398.jpg";